export default class GroupPermissions {

  constructor() {
    const treeview = $("#treeview");
    if (treeview.length) {
      this.initialize(treeview);
    }
  }

  initialize(treeview) {
    $.fn.hummingbird.defaults.SymbolPrefix = "fas";
    $.fn.hummingbird.defaults.collapsedSymbol = "fa-caret-up";
    $.fn.hummingbird.defaults.expandedSymbol = "fa-caret-down";

    treeview.hummingbird().hummingbird("expandAll");

    const treeHit = document.querySelectorAll('.tree-hit');

    treeHit.forEach(item => {
      item.addEventListener('click', (e) => {
        e.target.nextElementSibling.classList.toggle('folder-collapsed');
      });
    });

    var setViewValues = function() {
      const selectedNodes = {"id" : [], "dataid" : [], "text" : []};

      //get all checked nodes
      treeview.hummingbird("getChecked",{list:selectedNodes});
      treeview.hummingbird("getIndeterminate",{list:selectedNodes});

      const views = [];
      for (let i = 0; i < selectedNodes.id.length; i++) {
        views.push(selectedNodes.id[i]);
      }

      const viewInput = document.getElementById('views');
      if (views.length) {
        viewInput.value = views.join(',');
      } else {
        viewInput.value = '';
      }
    };

    setViewValues();
    treeview.on("CheckUncheckDone", setViewValues);
  }

}
